import { ComponentBase } from '../../views/component-base';
import { AppState } from '../../store/app.states';
import {
  superannuationProviderSearch_Form,
  superannuationProviderSearch_List,
  superannuationProviderSearch_isSearchLoading,
} from './selectors';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import {
  ClearSearchAction,
  RequestAction,
  ResetAction,
} from './actions';
import { SuperannuationProviderItemModel } from './state';
import { debounceTime } from 'rxjs/operators';
import {
} from 'src/app/store/common/common.selectors';
import { ProviderSearchModel } from 'src/app/model/provider-search.model';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  EntryFieldComponent,
} from '@ifaa-components/ui-components';
import { NgrxFormsModule } from 'ngrx-forms';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-superannuation-provider-search',
  templateUrl: './superannuation-provider-search.component.html',
  styleUrls: ['./superannuation-provider-search.component.scss'],
  imports: [
    AsyncPipe,
    EntryFieldComponent,
    NgrxFormsModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressBar,
    NgIf,
    MatError,
    MatIcon,
    NgForOf,
  ],
})
export class SuperannuationProviderSearchComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  @Output() onSelected = new EventEmitter<any>();

  form$ = this.store.pipe(select(superannuationProviderSearch_Form));
  list$ = this.store.pipe(select(superannuationProviderSearch_List));
  isSearchLoading$ = this.store.pipe(
    select(superannuationProviderSearch_isSearchLoading)
  );
  
  @Input() hidesearch: boolean = false;

  q: string = '';
  fundUsiList: string[] = [];

  constructor(public store: Store<AppState>) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();

    this.sub = this.form$.pipe(debounceTime(300)).subscribe((x) => {
      if (this.q != x.value.q && x.value.q) {
        this.q = x.value.q;
        var request = new ProviderSearchModel();
        request.query = this.q;
        request.fundUsiList = this.fundUsiList;
        this.store.dispatch(RequestAction({ data: request }));
      }

      if (x.value.selected && x.value.selected.superannuationProviderId) {
        this.hidesearch = true;
        this.onSelected.emit({
          id: x.value.selected.superannuationProviderId,
          usi: x.value.selected.usi,
          name: x.value.selected.name,
        });
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
    this.store.dispatch(ResetAction());
  }

  onClearClick() {
    this.q = '';
    this.hidesearch = false;
    this.store.dispatch(ResetAction());
    this.onSelected.emit({ id: 0, usi: '', name: '' });
  }

  onSelectOption(item: SuperannuationProviderItemModel) {
    this.hidesearch = false;
    this.onSelected.emit({
      id: item.superannuationProviderId,
      usi: item.usi,
      product: item.productName,
      abn: item.abn,
      name: item.name,
    });
  }

  onCloseClick() {
    this.store.dispatch(ClearSearchAction());
  }
}
